"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addDayToDate = void 0;
const tslib_1 = require("tslib");
const dayjs_1 = tslib_1.__importDefault(require("dayjs"));
const addDayToDate = (numberOfDay) => {
    return (0, dayjs_1.default)().add(numberOfDay, 'days').toDate();
};
exports.addDayToDate = addDayToDate;
